import styled from "@emotion/styled";
export const PaymentStyled = styled.div``;
